import { Form, Link } from 'react-router-dom';
import Field from './form/Field.jsx'
import Button from './Button.jsx'

export default function FormUpdatePassword({responseData, isSubmitting}) {

  function currentPasswordHasError(responseData) {
    if (responseData && responseData.errors && responseData.errors.detail && responseData.errors.detail === 'current password is invalid') {
      return "Senha atual incorreta."
    }

    return ""
  }

  function newPasswordHasError(respData) {
    if (respData && respData.errors && responseData.errors.detail && respData.errors.detail === 'password has an invalid format') {
      return "Mínimo de 8 caracteres com uma letra maíscula, uma minuscula, um número e um caractere especial."
    }

    return ""
  }

  function newPasswordConfirmationHasError(respData) {
    if (respData && respData.errors && responseData.errors.detail && respData.errors.detail === 'new password and confirmation password are different') {
      return "Senha de confirmação é inválida."
    }

    return ""
  }

  return (
    <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
      <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
        <Form method="PUT" className="space-y-4 md:space-y-6">

          <Field type={"password"} name={"current_password"} id={"current_password"} label={"Senha atual"} required={""} maxLength={50} defaultValue={""} error={currentPasswordHasError(responseData)} />
          <Field type={"password"} name={"new_password"} id={"new_password"} label={"Nova Senha"} required={""} maxLength={50} defaultValue={""} error={newPasswordHasError(responseData)}/>
          <Field type={"password"} name={"new_password_confirmation"} id={"new_password_confirmation"} label={"Confirme a nova senha"} required={""} maxLength={50} defaultValue={""} error={newPasswordConfirmationHasError(responseData)}/>

          <Button styleName="green" className="w-full" disabled={isSubmitting}>
            {isSubmitting ? 'Salvando...' : 'Salvar'}
          </Button>

          <div className="text-center text-sm">
            <Link className="font-medium text-green-600 hover:underline" to={"/"}>Cancelar</Link>
          </div>
        </Form>
      </div>
    </div>
  )

}